import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  CreazionePraticaTipologicheService
} from 'src/app/pratica/components/wizard-creazione/services/creazione-pratica-tipologiche.service';
import { DatiGeneraliConFondoRischiForm } from "../../../common/form/dati-generali-con-fondo-rischi-form";
import { TipoNatura } from "../../../common/models/tipologiche/tipo-natura";
import { TipoTipologica } from '../../../common/models/tipologiche/tipo-tipologica';
import { HelpersService } from "../../../core/services/helpers.service";
import { OperationsService } from "../../../core/services/operations.service";
import { TipoVisibilita } from 'src/app/common/models/tipologiche/tipo-visibilita';
import { UserManager } from 'src/app/core/services/user-manager';
import { AppData } from 'src/app/data-store';
import { MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ProtocolMetadata } from 'src/app/common/protocol/models/protocol';

@Component({
  selector: 'app-form-sinistro-sanitario',
  templateUrl: './form-sinistro-sanitario.component.html',
  styleUrls: ['./form-sinistro-sanitario.component.css']
})
export class FormSinistroSanitarioComponent extends DatiGeneraliConFondoRischiForm implements OnInit, OnChanges {

  datiGeneraliForm: FormGroup;
  tipiNatura: TipoNatura[] = [];
  idPratica: string;
  tipoFascicolo: string;
  tipoPratica: number;

  flagRct: boolean = false;
  flagRco: boolean = false;

  tipiVisibilitaOptions: TipoVisibilita[] = [];
  tipiDannoOptions: TipoTipologica[] = [];
  tipiPresidiOptions: TipoTipologica[] = [];
  canaliOptions: TipoTipologica[] = [];
  tipoValutazioneOptions: TipoTipologica[] = [];
  statoLavorazioneOptions: TipoTipologica[] = [];
  metadataFormValid: boolean = false;
  protocollo: ProtocolMetadata;

  @Input() fascicolo;
  @Input() request;
  @Input() nomeFascicolo;
  @Input() labelCreatoDaSistema;
  @Input() minervaWizard = false;
  @Output() saveForm = new EventEmitter();
  @Output() resetForm = new EventEmitter();
  @Output() createForm = new EventEmitter();

  constructor(protected operationService: OperationsService, private campiForm: FormBuilder, private helpers: HelpersService, private tipologicheService: CreazionePraticaTipologicheService) {
    super();
  }

  ngOnInit() {
    this.createFascicoloForm(true);
    this.populateSelect();
    this.inizializzaFondoRischi(this.request.fascicolo.flagFondoRischi, this.request.fascicolo.dataVariazioneFondoRischi);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.request && changes.request.currentValue) {
      this.createFascicoloForm();
    }
  }

  createFascicoloForm(init = false) {
    this.datiGeneraliForm = this.campiForm.group({
      natura: [init ? null : this.request.fascicolo.natura, Validators.required],
      stato: [init ? null : this.request.fascicolo.stato],
      tipoVisibilita: [init ? null : this.request.fascicolo.tipoVisibilita],
      dataInizioFascicolo: [init ? null : this.request.fascicolo.dataInizioFascicolo, Validators.required],
      dataDefinizione: [init ? null : this.request.fascicolo.dataDefinizione],
      motivoDefinizione: [init ? null : this.request.fascicolo.motivoDefinizione],
      flagProcessoTelematico: [init ? null : this.request.fascicolo.flagProcessoTelematico],
      flagFondoRischi: [init ? null : this.request.fascicolo.flagFondoRischi],
      dataVariazioneFondoRischi: [init ? null : this.request.fascicolo.dataVariazioneFondoRischi],
      recuperoCrediti: [init ? null : this.request.fascicolo.recuperoCrediti],
      note: [init ? null : this.request.fascicolo.note],
      definito: [init ? null : this.request.fascicolo.definito],
      dataSinistro: [init ? null : this.request.fascicolo.dataSinistro, Validators.required],
      dataDenuncia: [init ? null : this.request.fascicolo.dataDenuncia, Validators.required],
      nSinistro: [init ? null : this.request.fascicolo.nSinistro],
      canaleApertura: [init ? null : this.request.fascicolo.canaleApertura],
      tipoGestioneSinistro: [init ? null : this.request.fascicolo.tipoGestioneSinistro, Validators.required],
      protocolloDenuncia: [init ? null : this.request.fascicolo.protocolloDenuncia],
      tipoResponsabilita: [init ? null : this.request.fascicolo.tipoResponsabilita,Validators.required],
      descrizione: [init ? null : this.request.fascicolo.descrizione],
      luogo: [init ? null : this.request.fascicolo.luogo],
      presidioDistretto: [init ? null : this.request.fascicolo.presidioDistretto],
      tipoDanno: [init ? null : this.request.fascicolo.tipoDanno],
      morte: [init ? null : this.request.fascicolo.morte],
      tipoValutazione: [init ? null : this.request.fascicolo.tipoValutazione],
      statoLavorazione: [init ? null : this.request.fascicolo.statoLavorazione],
      metadata: [init ? null : this.request.fascicolo.metadata],
      descrizioneOggetto: [init ? null : this.request.fascicolo.descrizioneOggetto, Validators.required],
    });
    if(this.minervaWizard){
      this.createForm.emit();
    }
    this.readProtocollo()
  }

  setDefaultFondoRischi() {
    this.request.fascicolo.flagFondoRischi = false;

  }
  populateSelect() {
    this.tipologicheService.getTipiNatura().subscribe(response => this.tipiNatura = response);
    if(AppData.getInstance().tipiVisibilitaOptions.length > 0) {
      this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
    } else {
      this.helpers.getRolesByUserData().subscribe(
        () => {
          this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
        }
      )
    }
    this.helpers.getTipiDanno().subscribe(res => {
      this.tipiDannoOptions = res;
    })
    this.helpers.getPresidi().subscribe(res => {
      this.tipiPresidiOptions = res;
    })
    this.helpers.getCanaliApertura().subscribe(response=>this.canaliOptions=response);
    this.helpers.getTipiValutazione().subscribe(response => this.tipoValutazioneOptions = response)
    this.helpers.getStatiLavorazione().subscribe(response => this.statoLavorazioneOptions = response)
  }

  isFormMetadataValid(value: boolean){
    this.metadataFormValid = value;
  }

  onRetrieve(value : MetadataExt[]){
    this.request.fascicolo.metadata = value.map(value => value);
  }

  onDataProtocol(value: ProtocolMetadata) {
    if (value) {
      this.request.fascicolo.numeroFascicoloProtocollo = value.dossierNumber;
      this.request.fascicolo.numeroProtocollo = value.protocolNumber;
      this.request.fascicolo.dataProtocollazione = value.protocolTimestamp;
      this.request.fascicolo.oggettoProtocollo = value.subject;
      this.request.fascicolo.senderReceiver = value.senderReceiver;
      this.request.fascicolo.utenteProtocollatore = value.protocolUser;
      this.request.fascicolo.inUscita = value.tipoReg.toLowerCase() === "in uscita";
      this.request.fascicolo.protocolDocuments = value.protocolDocuments.map(d => (d.documentRef));
    } else {
      this.request.fascicolo.numeroFascicoloProtocollo = null;
      this.request.fascicolo.numeroProtocollo = null;
      this.request.fascicolo.dataProtocollazione = null;
      this.request.fascicolo.oggettoProtocollo = null;
      this.request.fascicolo.senderReceiver = null;
      this.request.fascicolo.utenteProtocollatore = null;
      this.request.fascicolo.inUscita = null;
      this.request.fascicolo.protocolDocuments = null;
    }
  }
  readProtocollo() {
    if(this.fascicolo.numeroProtocollo){
      this.protocollo={
      dossierNumber: this.fascicolo.numeroFascicoloProtocollo,
      protocolNumber: this.fascicolo.numeroProtocollo,
      protocolTimestamp: this.fascicolo.dataProtocollazione,
      subject: this.fascicolo.oggettoProtocollo,
      senderReceiver:this.fascicolo.senderReceiver,
      protocolUser: this.fascicolo.utenteProtocollatore,
      tipoReg: this.fascicolo.inUscita ? "IN USCITA" : "IN ENTRATA"
    }}
  }
  
  save() {
    this.saveForm.emit();
  }

}
